module.exports = __webpack_public_path__ + "img/cursor.dd5ce816.svg";